document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.referral-popup');

  if (!popup) return;

  const wrapper = popup.querySelector('.referral-popup__wrapper');
  const overlay = popup.querySelector('.referral-popup__overlay');
  const closeBtn = popup.querySelector('.referral-popup__close');

  const delay = Number(popup.dataset.delay || 0) * 1000;
  const showOnce = popup.dataset.showOnce === 'true';
  const storageKey = 'referral-popup-shown';

  // Don't show again if already viewed
  if (showOnce && localStorage.getItem(storageKey) === 'true') {
    return;
  }

  // Open Popup
  function openPopup() {
    popup.classList.add('is-visible');
    document.documentElement.classList.add('referral-popup-open');
    document.body.classList.add('referral-popup-open');
  }

  // Close Popup
  function closePopup() {
    popup.classList.remove('is-visible');
    document.documentElement.classList.remove('referral-popup-open');
    document.body.classList.remove('referral-popup-open');

    if (showOnce) {
      localStorage.setItem(storageKey, 'true');
    }
  }

  // Show after delay
  setTimeout(openPopup, delay);

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  // Click outside
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  // ESC key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup();
    }
  });

  // Prevent closing when clicking inside popup
  if (wrapper) {
    wrapper.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  // Auto-close after successful submission
  const success = popup.querySelector('.referral-popup__success');

  if (success) {
    if (showOnce) {
      localStorage.setItem(storageKey, 'true');
    }

    setTimeout(function () {
      closePopup();
    }, 3000);
  }
});